var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  default: () => microsoftClarity2,
  microsoftClarityDir: () => microsoftClarity
});
module.exports = __toCommonJS(src_exports);
var import_path = __toESM(require("path"));

// src/plugins/microsoft-clarity.ts
var import_vue = __toESM(require("vue"));
var microsoftClarity = {
  bind(el, binding, vnode) {
    microsoftClarityFn(binding.value);
  }
};
function microsoftClarityFn(user) {
  if (user && typeof window.clarity !== "undefined" && typeof window.clarity === "function") {
    window.clarity("identify", `${user.ggId}`, void 0, `${user.projectName}`, `${user.email}`);
    window.clarity("set", "ggId", user.ggId);
    window.clarity("set", "username", user.username);
    window.clarity("set", "email", user.email);
  }
}
import_vue.default.directive("microsoft-clarity", microsoftClarity);

// src/index.ts
function microsoftClarity2() {
  if (this.addPlugin) {
    this.addPlugin(import_path.default.resolve(__dirname, "plugins/microsoft-clarity.js"));
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  microsoftClarityDir
});
//# sourceMappingURL=index.js.map